import type { IBadgeProps } from '../../types'

import * as S from './index.styles'

export function Badge({
  children,
  size = 'md',
  disabled = false,
  readOnly = false,
  ...rest
}: IBadgeProps) {
  const value = Number(children)

  const quantity = value > 9 ? '9+' : value

  return (
    <S.BadgeContainer
      {...rest}
      size={size}
      disabled={disabled}
      readOnly={readOnly}
    >
      <S.BadgeText>{quantity}</S.BadgeText>
    </S.BadgeContainer>
  )
}
